import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import useSWR from 'swr'

export const useEthBalance = () => {
  const { walletAddress, library } = useWeb3()

  const data = useSWR(`eth-balance-${walletAddress}`, async () => {
    if (!library || !walletAddress) return null

    const balance = await library.getBalance(walletAddress)
    return balance
  })

  return data
}
